import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// Authenticated pages
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Pickup = lazy(() => import('../pages/Pickup'));
const BulkWaste = lazy(() => import('../pages/BulkWaste'));
const History = lazy(() => import('../pages/History'));
const ViolationsDashboard = lazy(() => import('../pages/ViolationsDashboard'));
const CreateViolation = lazy(() => import('../pages/CreateViolation'));
const EditViolation = lazy(() => import('../pages/EditViolation'));
const Complaints = lazy(() => import('../pages/Complaints'));
const CreateComplaint = lazy(() => import('../pages/CreateComplaint'));
const EditComplaint = lazy(() => import('../pages/EditComplaint'));
const Store = lazy(() => import('../pages/Store'));
const Notifications = lazy(() => import('../pages/Notifications'));
const Settings = lazy(() => import('../pages/Settings'));

const authenticatedRoutes = [
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/pickup',
    element: (
      <ProtectedRoute>
        <Pickup />
      </ProtectedRoute>
    ),
  },
  {
    path: '/bulk-waste',
    element: (
      <ProtectedRoute>
        <BulkWaste />
      </ProtectedRoute>
    ),
  },
  {
    path: '/history',
    element: (
      <ProtectedRoute>
        <History />
      </ProtectedRoute>
    ),
  },
  {
    path: '/violations-report',
    element: (
      <ProtectedRoute>
        <ViolationsDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/violations/create',
    element: (
      <ProtectedRoute>
        <CreateViolation />
      </ProtectedRoute>
    ),
  },
  {
    path: '/violations/edit/:id',
    element: (
      <ProtectedRoute>
        <EditViolation />
      </ProtectedRoute>
    ),
  },
  {
    path: '/complaints',
    element: (
      <ProtectedRoute>
        <Complaints />
      </ProtectedRoute>
    ),
  },
  {
    path: '/complaints/create',
    element: (
      <ProtectedRoute>
        <CreateComplaint />
      </ProtectedRoute>
    ),
  },
  {
    path: '/complaints/edit/:id',
    element: (
      <ProtectedRoute>
        <EditComplaint />
      </ProtectedRoute>
    ),
  },
  {
    path: '/store',
    element: (
      <ProtectedRoute>
        <Store />
      </ProtectedRoute>
    ),
  },
  {
    path: '/notifications',
    element: (
      <ProtectedRoute>
        <Notifications />
      </ProtectedRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },

  {
    path: '/pickup',
    element: (
      <ProtectedRoute>
        <Pickup />
      </ProtectedRoute>
    ),
  }
];

export default authenticatedRoutes;

